import { render, staticRenderFns } from "./ChartBulanan.vue?vue&type=template&id=1890aa3d&scoped=true"
import script from "./ChartBulanan.vue?vue&type=script&lang=js"
export * from "./ChartBulanan.vue?vue&type=script&lang=js"
import style0 from "./ChartBulanan.vue?vue&type=style&index=0&id=1890aa3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1890aa3d",
  null
  
)

export default component.exports